import React, { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';

import FieldSelect from './FieldSelect.jsx';
import { updateField } from '../../actions/form';

export class FieldSelectWithOther extends Component {
  constructor(props) {
    super(props);
    this.onInputChange = this.onInputChange.bind(this);
    this.getValue = this.getValue.bind(this);

    this.parseValueToSubmit = (value) => {
      if (_.isEmpty(value)) {
        return 'Other';
      }

      return value;
    };
  }

  onInputChange(e) {
    this.props.updateField(this.props.type, this.props.field, this.parseValueToSubmit(e.target.value));
  }

  getValue() {
    if (this.props.fieldValue === 'Other') {
      return '';
    }

    return this.props.fieldValue;
  }

  renderOther() {
    if (!_.isEmpty(this.props.fieldValue) && !_.find(this.props.options, { slug: this.props.fieldValue })) {
      return (
        <FormGroup>
          <FormControl
            type="text"
            name={this.props.title}
            className="select-feedback"
            onChange={this.onInputChange}
            placeholder={`Other ${_.startCase(this.props.field)} *`}
            value={this.getValue()}
          />
          <FormControl.Feedback />
        </FormGroup>
      );
    }

    return null;
  }

  render() {
    return (
      <div>
        <FieldSelect
          {...this.props}
          otherOption="Other"
        />
        { this.renderOther() }
       </div>
    );
  }
}

export const mapStateToProps = (state, ownProps) => ({
  fieldValue: _.get(state, `form.${state.ui.ratingType}.fields.${ownProps.field}`),
  type: _.get(state, 'ui.ratingType'),
});

export default connect(
  mapStateToProps,
  { updateField },
)(FieldSelectWithOther);
